import { render, staticRenderFns } from "./BgsSdk.vue?vue&type=template&id=418e3054&scoped=true"
import script from "./BgsSdk.vue?vue&type=script&lang=js"
export * from "./BgsSdk.vue?vue&type=script&lang=js"
import style0 from "./BgsSdk.vue?vue&type=style&index=0&id=418e3054&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418e3054",
  null
  
)

export default component.exports